const DefaultTimezone = 'UTC';

export default DefaultTimezone;
